"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Simulation = void 0;
const bubble_1 = require("./bubble");
const canvas_1 = require("./canvas");
const lodash_1 = require("lodash");
class Simulation {
    constructor() {
        this.canvas = new canvas_1.Canvas();
        this.bubbles = bubble_1.Bubble.createRandomBubbles(300);
        this.previousTime = performance.now();
        this.lag = 0;
    }
    start() {
        setInterval(() => {
            this.tick();
        }, 1000 / 20);
    }
    tick() {
        const currentTime = performance.now();
        const elapsed = currentTime - this.previousTime;
        this.previousTime = currentTime;
        this.lag += elapsed;
        while (this.lag >= 1000 / 20) {
            this.updateSimulation();
            this.lag -= 1000 / 20;
        }
        this.renderSimulation();
    }
    updateSimulation() {
        this.bubbles.forEach(bubble => bubble.updateVelocity(this.bubbles));
        this.bubbles.forEach(bubble => bubble.updatePosition());
        this.applyHotAndCold();
    }
    applyHotAndCold() {
        this.bubbles.sort((a, b) => {
            return a.position.y - b.position.y;
        });
        const groupSize = this.bubbles.length / 20;
        const highestGroup = lodash_1.take(this.bubbles.filter(bubble => bubble.heat > 10), groupSize);
        const lowestGroup = lodash_1.takeRight(this.bubbles, groupSize);
        highestGroup.forEach(bubble => bubble.coolDown());
        lowestGroup.forEach(bubble => bubble.heatUp());
    }
    renderSimulation() {
        this.canvas.draw(this.bubbles);
    }
}
exports.Simulation = Simulation;
//# sourceMappingURL=simulation.js.map